<ng-template #upgradeTemplate>
  <div role="tooltip" class="!tw-whitespace-normal" id="{{ getTooltipId() }}">
    This feature is part of
    <a class="madero-link" href="#" (click)="showUpgradeModal()"
      >{{ requiredPlan }} Plan</a
    >.
  </div>
</ng-template>
<mat-icon
  svgIcon="upgrade"
  #popoverDirective="bs-popover"
  [popover]="upgradeTemplate"
  ariaLabel="More information"
  [attr.aria-describedby]="getTooltipId()"
  placement="right"
  boundariesElement="window"
  container="body"
  containerClass="upgrade-popover"
  triggers="mouseenter:click focus:blur"
  [outsideClick]="true"
  class="u_clickable"
  [ngClass]="{ 'upgrade-overlay': overlay }"
  (click)="showUpgradeModal(); $event.stopPropagation()"
  (keydown.enter)="showUpgradeModal(); $event.stopPropagation()"
  (keydown.space)="showUpgradeModal(); $event.stopPropagation()"
/>
